import React from "react";
import "./Drawer.css";

const Drawer = ({ isOpen, setIsOpen, children, width, height, overflow }) => {
  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div
        className={`drawer-overlay ${isOpen ? "open" : ""}`}
        onClick={toggleDrawer}
      >
        <div
          className={`drawer-content ${isOpen ? "open" : ""}`}
          style={{ width, height, overflow }}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
